import { IPage, ISearchPage } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import { httpRequest } from "@/utils/HttpRequest";


//详情
export interface ICustomerDiscountDetail {
    id: string,      // "809099881aaa407988b263d6c47bb285"
    accountArrears: string,      // "4.00"
    accountCode: string,      // "4"
    applyExplain: string,      // "我是一个审核说明"
    audit: string,      // null
    auditExplain: string,      // null
    auditTime: string,      // null
    bentityCode: string,      // "1"
    bentityName: string,      // "2"
    casher: string,      // null
    casherExplain: string,      // "我是一个审核说明"
    casherTime: string,      // null
    code: string,      // "KHYH202107230001"
    contact: string,      // "4"
    createTime: string,      // "2021-07-23 08:string,      //43:string,      //55"
    createUser: string,      // "管理员"
    customerCode: string,      // "3"
    customerName: string,      // "4"
    deleteFlag: string,      // 0
    orderNum: string,      // null
    phone: string,      // "4"
    shopCode: string,      // "4"
    shopName: string,      // "4"
    status: string,      // "1"
    updateTime: string,      // "2021-07-23 09:string,      //09:string,      //58"
    updateUser: string,      // "管理员"
}
//新增
export interface ICustomerDiscountInsert extends ICustomerDiscountFormFields {

}

//编辑
export interface ICustomerDiscountUpdate extends ICustomerDiscountInsert {
    id: string,
}

//搜索条件
export interface ICustomerDiscountSearchFields {
    "code"?: string,   // "客户优惠单号",
    "customerName"?: string,   // "客户名称",
    "status"?: string,   // "状态",
    "createUser"?: string,   // "申请人",
    "startTime"?: string,   // "开始时间",
    "endTime"?: string,   // "结束时间",
    "audit"?: string,   // "机构审核人",
    "casher"?: string,   // "财务审核人"
}

export interface ICustomerDiscountSearch
    extends ICustomerDiscountSearchFields, ISearchPage {

}

//表单字段
export interface ICustomerDiscountFormFields {
    "id"?: string,
    "bentityCode"?: string,  // "实体编码",
    "bentityName"?: string,  // "实体名称",
    "customerCode"?: string,  // "客户编码",
    "customerName"?: string,  // "客户名称",
    "contact"?: string,  // "联系人",
    "phone"?: string,  // "联系方式",
    "shopCode"?: string,  // "门店编码",
    "shopName"?: string,  // "门店名称",
    "accountCode"?: string,  // "账户编码",
    "accountArrears"?: string,  // "账户欠款余额"
    "discountAmount"?: string,  // "优惠金额"
    "createUser"?: string,
    "code"?: string,
    "status"?: string,
    [key: string]: any
}

//机构审核
export interface IApplyAuditExamined {
    "id": string,  // "809099881aaa407988b263d6c47bb285",
    "isAgre": string,  // "0",
    "advise": string,  // "我是一个审核说明"
}
class CustomerDiscountService {
    async page(searchVo: ICustomerDiscountSearch, config: object = {}) {
        const apiUrl = "/apply/page";
        return await httpRequest.post<IPage<ICustomerDiscountDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/apply/one/${id}`;
        return await httpRequest.get<ICustomerDiscountDetail>(apiUrl);
    }
    async insert(insertVo: ICustomerDiscountInsert) {
        const apiUrl = "/apply/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ICustomerDiscountUpdate) {
        const apiUrl = "/apply/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //机构审核
    async auditExamined(vo: IApplyAuditExamined) {
        const apiUrl = "/apply/auditExamined";
        return await httpRequest.post<boolean>(apiUrl, vo);
    }
    //财务审核
    async casherExamined(vo: IApplyAuditExamined) {
        const apiUrl = "/apply/casherExamined";
        return await httpRequest.post<boolean>(apiUrl, vo);
    }
    //导出
    async export(searchVo: ICustomerDiscountSearch) {
        const appPageUrl = "/apply/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

}

export const customerDiscountService = new CustomerDiscountService();
